import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { map } from 'rxjs/operators';
import { UserLoginInfoDto } from '../../../../models/UserLoginInfoDto';
@Injectable({
  providedIn: 'root'
})
export class SrcExamLoginService {
  constructor(private http: HttpClient) { }
  login(sLoginDto: UserLoginInfoDto) {
    return this.http.post(EndpointsConfig.examinee.login,
      JSON.stringify({ MailAdress: sLoginDto.MailAdress, Password: sLoginDto.Password, SavePass: sLoginDto.SavePass }));
  }
  GetToken() {
    return this.http.get<any>(EndpointsConfig.examinee.getToken);
  }
  UpdateInfoUser(sLoginDto: UserLoginInfoDto) {
    return this.http.post(EndpointsConfig.examinee.UpdateInfoUser,
      JSON.stringify({ HTOrgCode: sLoginDto.HTOrgCode, UserID: sLoginDto.UserID, ConsulID: sLoginDto.ConsulID }));
  }
}
